import { fromJS } from 'immutable';

export const initialState = {
  info: fromJS({
    description: 'Controle de Processos',
    area_icon: 'administracao-small.png',
    module_icon: 'administracao-controleprocessos-small.png'
  })
};
